import script from "./ProgramTargets.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramTargets.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__